module.exports = __webpack_public_path__ + "static/media/delete_file.1890a852.svg";